export const GET_REVENUE_PLAN_HO = `query GetAllRevenueHo($input:TrevenueHoWhereInput!,$skip:Float,$take:Float){
    getRevenueHo(where: $input,skip:$skip,take:$take,orderBy:{createDate: DESC}){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            plantId
            tplant{
                id
                name
            }
            typeRevenue
            ttypeRevenue{
                id 
                name
                value
                status
            }
            unitMoney
            aprSaleamt
            augSaleamt
            decSaleamt
            febSaleamt
            janSaleamt
            julSaleamt
            junSaleamt
            marSaleamt
            maySaleamt
            novSaleamt
            octSaleamt
            sepSaleamt
            year
            totalYearSaleamt
            createDate
            modifyDate
            tcreateUser{
                fullName
            }
            tmodifyUser{
                fullName
            }
        }
    }
}`;

export const GET_REVENUE_PLAN_HO_DETAIL = `
query GetRevenuePlanHoById(
  $input: TrevenuePlanHoWhereInput
  $skip: Float
  $take: Float
) {
  getRevenuePlanHo(where: $input, skip: $skip, take: $take) {
    pageInfo {
      currentPage
      hasNextPage
      hasPreviousPage
      itemsPerPage
      totalItems
      totalPages
    }
    items {
      id
      aprSaleamt
      aprProfitSaleamt
      augSaleamt
      augProfitSaleamt
      plantId
      tplant {
        id
        name
      }
      approval {
        id
        fullName
        avatar
      }
      decProfitSaleamt
      decSaleamt
      febProfitSaleamt
      febSaleamt
      janProfitSaleamt
      janSaleamt
      julProfitSaleamt
      julSaleamt
      junProfitSaleamt
      junSaleamt
      marProfitSaleamt
      marSaleamt
      mayProfitSaleamt
      maySaleamt
      novProfitSaleamt
      novSaleamt
      octProfitSaleamt
      octSaleamt
      sepProfitSaleamt
      sepSaleamt
      totalYearSaleamt
      unitMoney
      year
      createDate
      modifyDate
      grossProfitPlanAmt
      netRevenuePlanAmt
      tcreateUser{
        id
        fullName
      }
      tmodifyUser{
        id
        fullName
      }
      trevenuePlanBranches {
        id
        plantId
        tplant {
          id
          name
        }
        aprSaleamt
        aprProfitSaleamt
        augSaleamt
        augProfitSaleamt
        decProfitSaleamt
        decSaleamt
        febProfitSaleamt
        febSaleamt
        janProfitSaleamt
        janSaleamt
        julProfitSaleamt
        julSaleamt
        junProfitSaleamt
        junSaleamt
        marProfitSaleamt
        marSaleamt
        mayProfitSaleamt
        maySaleamt
        novProfitSaleamt
        novSaleamt
        octProfitSaleamt
        octSaleamt
        sepProfitSaleamt
        sepSaleamt
        totalYearSaleamt
        unitMoney
        year
        createDate
      }
    }
  }
}`;

export const UPDATE_REVENUE_PLAN_HO = `
mutation UpdateRevenueHo($input:TrevenueHoInput!){
    updateRevenueHo(input:$input){
            id
            plantId
            totalYearSaleamt
              ttypeRevenue{
                id
                name
                value
            }
            typeRevenue
            janSaleamt
            febSaleamt
            marSaleamt
            aprSaleamt
            maySaleamt
            julSaleamt
            augSaleamt
            octSaleamt
            sepSaleamt
            novSaleamt
            decSaleamt
            year
    }
}`;

export const CREATE_REVENUE_PLAN_HO = `
mutation CreateRevenueHo($input:TrevenueHoInput!){
    createRevenueHo(input:$input){
            id
            plantId
            totalYearSaleamt
            year
            janSaleamt
            febSaleamt
            marSaleamt
            aprSaleamt
            maySaleamt
            julSaleamt
            augSaleamt
            octSaleamt
            sepSaleamt
            novSaleamt
            decSaleamt
            typeRevenue
    }
}
`;

export const DELETE_REVENUE_PLAN_HO = `mutation UpdateRevenuePlanHoById($id: String!) {
  deleteRevenuePlanHo(id: $id){
    code
    message
    success
  }
}`;

export const CHECK_EXISTED = `
query GetRevenueHo($input:TrevenueHoWhereInput){
    getRevenueHo(where:$input){
        items{
            id
            plantId
            tplant {
            name
            }
            typeRevenue
            year
        }
    }
}`;

export const GET_REVENUE_PLAN_HO_YEAR_BY_PLANTID = `
 query GetAllRevenueHo($input:TrevenueHoWhereInput
$skip: Float
  $take: Float){
    getRevenueHo(where: $input, skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
           id
           plantId
            ttypeRevenue{
                id
                name
                value
            }
            tplant{
                id
                name
            }
            typeRevenue
            year
            janSaleamt
            febSaleamt
            marSaleamt
            aprSaleamt
            maySaleamt
            junSaleamt
            julSaleamt
            augSaleamt
            octSaleamt
            sepSaleamt
            novSaleamt
            decSaleamt
            totalYearSaleamt
            createDate
            createId
            modifyDate
            modifyId
        }
    }
}
`;

export const GET_PROGRESS_REVENUE_PLAN_HO = `
  query GetProgressRevenuePlanHo(
    $input: ProgressRevenuePlantInput!
  ) {
    getProgressRevenuePlantHO(where: $input) {
      plantId
      plantName
      yr
      progressRevenuePlant{
          mon
          sumFinalPrice
          percentPrice
      }
    }
  }
`;

export const GET_PROGRESS_REVENUE_PLAN_BRANCH = `
  query GetProgressRevenuePlanBranch(
    $input: ProgressRevenuePlantInput!
  ) {
    getProgressRevenuePlantTeamSale(where: $input) {
      plantId
      tteamSalesId
      yr
      progressRevenuePlant{
          mon
          sumFinalPrice
          percentPrice
      }
    }
  }
`;

export const GET_PROGRESS_REVENUE_PLAN_TEAM_SALE = `
  query GetProgressRevenuePlanTeamSale(
    $input: ProgressRevenuePlantInput!
  ) {
    getProgressRevenuePlant(where: $input) {
      plantId
      tteamSalesId
      yr
      progressRevenuePlant{
          mon
          sumFinalPrice
          percentPrice
      }
    }
  }
`;

// get Track Revenue Ho
export const GET_TRACK_REVENUE_HO = `
  query GetTrackRevenueHo($input: RevenueHoTeamsaleInput!, $skip: Float!, $take: Float!){
      getTrackRevenueHo(input: $input, skip: $skip, take: $take){
          pageInfo{
              hasNextPage
              hasPreviousPage
              itemsPerPage
              currentPage
              totalItems
              totalPages
          }
          items{
              year
              plant_id
              plant_name
              type_revenue
              cumulative_plan
              year_plan
              realized_revenue
              cumulative_plan_percent
              percentage_achieved_year
              unit_money
              modify_name
              modify_date
          }
      }
  }
`;

// calculate Revenue Ho Teamsale
export const CALCULATE_REVENUE_HO_TEAM_SALE = `
  query data($input: CalculateRevenueHoTeamsaleInput!){
      calculateRevenueHoTeamsale(input: $input){
          message
          success
      }
  }
`;

// get Track Revenue Ho Detail
export const GET_TRACK_REVENUE_HO_DETAIL = `query GetTrackRevenueHo($input: RevenueHoTeamsaleDetailInput!){
    getTrackRevenueDetailHo(input: $input){
       process_revenue{
        revenue_plant{
            plant_name
            type_revenue
            month_revenue_1
            month_revenue_2
            month_revenue_3
            month_revenue_4
            month_revenue_5
            month_revenue_6
            month_revenue_7
            month_revenue_8
            month_revenue_9
            month_revenue_10
            month_revenue_11
            month_revenue_12
            total_year_revenue
            type_revenue_actual_1
            month_revenue_actual_1
            month_revenue_actual_2
            month_revenue_actual_3
            month_revenue_actual_4
            month_revenue_actual_5
            month_revenue_actual_6
            month_revenue_actual_7
            month_revenue_actual_8
            month_revenue_actual_9
            month_revenue_actual_10
            month_revenue_actual_11
            month_revenue_actual_12
            total_year_revenue_actual
            month_percent_1
            month_percent_2
            month_percent_3
            month_percent_4
            month_percent_5
            month_percent_6
            month_percent_7
            month_percent_8
            month_percent_9
            month_percent_10
            month_percent_11
            month_percent_12
            total_year_percent
        }
        total_month_revenue_1
        total_month_revenue_2
        total_month_revenue_3
        total_month_revenue_4
        total_month_revenue_5
        total_month_revenue_6
        total_month_revenue_7
        total_month_revenue_8
        total_month_revenue_9
        total_month_revenue_10
        total_month_revenue_11
        total_month_revenue_12
        total_year_revenue
        total_month_revenue_actual_1
        total_month_revenue_actual_2
        total_month_revenue_actual_3
        total_month_revenue_actual_4
        total_month_revenue_actual_5
        total_month_revenue_actual_6
        total_month_revenue_actual_7
        total_month_revenue_actual_8
        total_month_revenue_actual_9
        total_month_revenue_actual_10
        total_month_revenue_actual_11
        total_month_revenue_actual_12
        total_revenue_year_actual
        total_month_percent_1
        total_month_percent_2
        total_month_percent_3
        total_month_percent_4
        total_month_percent_5
        total_month_percent_6
        total_month_percent_7
        total_month_percent_8
        total_month_percent_9
        total_month_percent_10
        total_month_percent_11
        total_month_percent_12
        total_year_percent
       }
       profit_revenue{
            revenue_plant{
                plant_name
                type_revenue
                month_revenue_1
                month_revenue_2
                month_revenue_3
                month_revenue_4
                month_revenue_5
                month_revenue_6
                month_revenue_7
                month_revenue_8
                month_revenue_9
                month_revenue_10
                month_revenue_11
                month_revenue_12
                total_year_revenue
                type_revenue_actual_1
                month_revenue_actual_1
                month_revenue_actual_2
                month_revenue_actual_3
                month_revenue_actual_4
                month_revenue_actual_5
                month_revenue_actual_6
                month_revenue_actual_7
                month_revenue_actual_8
                month_revenue_actual_9
                month_revenue_actual_10
                month_revenue_actual_11
                month_revenue_actual_12
                total_year_revenue_actual
                month_percent_1
                month_percent_2
                month_percent_3
                month_percent_4
                month_percent_5
                month_percent_6
                month_percent_7
                month_percent_8
                month_percent_9
                month_percent_10
                month_percent_11
                month_percent_12
                total_year_percent
            }
            total_month_revenue_1
            total_month_revenue_2
            total_month_revenue_3
            total_month_revenue_4
            total_month_revenue_5
            total_month_revenue_6
            total_month_revenue_7
            total_month_revenue_8
            total_month_revenue_9
            total_month_revenue_10
            total_month_revenue_11
            total_month_revenue_12
            total_year_revenue
            total_month_revenue_actual_1
            total_month_revenue_actual_2
            total_month_revenue_actual_3
            total_month_revenue_actual_4
            total_month_revenue_actual_5
            total_month_revenue_actual_6
            total_month_revenue_actual_7
            total_month_revenue_actual_8
            total_month_revenue_actual_9
            total_month_revenue_actual_10
            total_month_revenue_actual_11
            total_month_revenue_actual_12
            total_revenue_year_actual
            total_month_percent_1
            total_month_percent_2
            total_month_percent_3
            total_month_percent_4
            total_month_percent_5
            total_month_percent_6
            total_month_percent_7
            total_month_percent_8
            total_month_percent_9
            total_month_percent_10
            total_month_percent_11
            total_month_percent_12
            total_year_percent
       }
       invoice_revenue{
            revenue_plant{
                plant_name
                type_revenue
                month_revenue_1
                month_revenue_2
                month_revenue_3
                month_revenue_4
                month_revenue_5
                month_revenue_6
                month_revenue_7
                month_revenue_8
                month_revenue_9
                month_revenue_10
                month_revenue_11
                month_revenue_12
                total_year_revenue
                type_revenue_actual_1
                month_revenue_actual_1
                month_revenue_actual_2
                month_revenue_actual_3
                month_revenue_actual_4
                month_revenue_actual_5
                month_revenue_actual_6
                month_revenue_actual_7
                month_revenue_actual_8
                month_revenue_actual_9
                month_revenue_actual_10
                month_revenue_actual_11
                month_revenue_actual_12
                total_year_revenue_actual
                month_percent_1
                month_percent_2
                month_percent_3
                month_percent_4
                month_percent_5
                month_percent_6
                month_percent_7
                month_percent_8
                month_percent_9
                month_percent_10
                month_percent_11
                month_percent_12
                total_year_percent
            }
            total_month_revenue_1
            total_month_revenue_2
            total_month_revenue_3
            total_month_revenue_4
            total_month_revenue_5
            total_month_revenue_6
            total_month_revenue_7
            total_month_revenue_8
            total_month_revenue_9
            total_month_revenue_10
            total_month_revenue_11
            total_month_revenue_12
            total_year_revenue
            total_month_revenue_actual_1
            total_month_revenue_actual_2
            total_month_revenue_actual_3
            total_month_revenue_actual_4
            total_month_revenue_actual_5
            total_month_revenue_actual_6
            total_month_revenue_actual_7
            total_month_revenue_actual_8
            total_month_revenue_actual_9
            total_month_revenue_actual_10
            total_month_revenue_actual_11
            total_month_revenue_actual_12
            total_revenue_year_actual
            total_month_percent_1
            total_month_percent_2
            total_month_percent_3
            total_month_percent_4
            total_month_percent_5
            total_month_percent_6
            total_month_percent_7
            total_month_percent_8
            total_month_percent_9
            total_month_percent_10
            total_month_percent_11
            total_month_percent_12
            total_year_percent
       }
       profit_tax{
            revenue_plant{
                plant_name
                type_revenue
                month_revenue_1
                month_revenue_2
                month_revenue_3
                month_revenue_4
                month_revenue_5
                month_revenue_6
                month_revenue_7
                month_revenue_8
                month_revenue_9
                month_revenue_10
                month_revenue_11
                month_revenue_12
                total_year_revenue
                type_revenue_actual_1
                month_revenue_actual_1
                month_revenue_actual_2
                month_revenue_actual_3
                month_revenue_actual_4
                month_revenue_actual_5
                month_revenue_actual_6
                month_revenue_actual_7
                month_revenue_actual_8
                month_revenue_actual_9
                month_revenue_actual_10
                month_revenue_actual_11
                month_revenue_actual_12
                total_year_revenue_actual
                month_percent_1
                month_percent_2
                month_percent_3
                month_percent_4
                month_percent_5
                month_percent_6
                month_percent_7
                month_percent_8
                month_percent_9
                month_percent_10
                month_percent_11
                month_percent_12
                total_year_percent
            }
            total_month_revenue_1
            total_month_revenue_2
            total_month_revenue_3
            total_month_revenue_4
            total_month_revenue_5
            total_month_revenue_6
            total_month_revenue_7
            total_month_revenue_8
            total_month_revenue_9
            total_month_revenue_10
            total_month_revenue_11
            total_month_revenue_12
            total_year_revenue
            total_month_revenue_actual_1
            total_month_revenue_actual_2
            total_month_revenue_actual_3
            total_month_revenue_actual_4
            total_month_revenue_actual_5
            total_month_revenue_actual_6
            total_month_revenue_actual_7
            total_month_revenue_actual_8
            total_month_revenue_actual_9
            total_month_revenue_actual_10
            total_month_revenue_actual_11
            total_month_revenue_actual_12
            total_revenue_year_actual
            total_month_percent_1
            total_month_percent_2
            total_month_percent_3
            total_month_percent_4
            total_month_percent_5
            total_month_percent_6
            total_month_percent_7
            total_month_percent_8
            total_month_percent_9
            total_month_percent_10
            total_month_percent_11
            total_month_percent_12
            total_year_percent
       }
    }
}`;
